function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaterLogo = function SvgWaterLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 190 228",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), React.createElement("g", {
    transform: "matrix(1,0,0,1,-305.189,-186)"
  }, React.createElement("g", {
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }, React.createElement("path", {
    d: "M3940,4085L3886,4030L4261,3653C4668,3242 4689,3216 4744,3050C4912,2544 4534,2020 4000,2020C3393,2020 3018,2680 3326,3205C3363,3268 3415,3327 3571,3485L3769,3685L4060,3395C4220,3236 4364,3085 4380,3061C4423,2997 4451,2915 4457,2834C4479,2547 4213,2302 3931,2350C3662,2395 3487,2659 3556,2915C3565,2948 3573,2980 3574,2986C3574,2992 3549,3025 3517,3059L3460,3122L3435,3068C3382,2952 3365,2795 3391,2668C3406,2597 3470,2466 3519,2407C3705,2185 4013,2118 4273,2244C4403,2307 4495,2401 4560,2535C4606,2632 4620,2694 4620,2808C4620,2913 4602,2990 4553,3090C4520,3160 4493,3189 4144,3540L3770,3915L3502,3645C3203,3343 3166,3292 3104,3111C2963,2701 3115,2255 3477,2013C3638,1906 3796,1860 4000,1860C4204,1860 4362,1906 4523,2013C4885,2255 5037,2702 4896,3112C4831,3303 4808,3332 4386,3758C4177,3968 4003,4140 4000,4140C3997,4140 3970,4115 3940,4085Z",
    style: {
      fill: "#61dafb",
      fillRule: "nonzero"
    }
  }), React.createElement("path", {
    d: "M3566,3249C3546,3233 3540,3220 3540,3188C3540,3148 3546,3141 3690,2995C3839,2845 3840,2844 3840,2799C3840,2748 3866,2701 3913,2666C3953,2637 4047,2637 4087,2666C4136,2703 4160,2748 4160,2805C4160,2895 4096,2961 4004,2964C3960,2966 3955,2971 3817,3107C3640,3282 3622,3293 3566,3249Z",
    style: {
      fill: "#61dafb",
      fillRule: "nonzero"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWaterLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water.logo.6752eded.svg";
export { ForwardRef as ReactComponent };